import * as React from 'react';

import { StarBorder } from '@mui/icons-material';
import { ListItemIcon, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

import { settings } from 'config';
import { useUserContext } from 'hooks';
import { RoleEnum } from 'types';

export interface roleSelectionProps {
  open: boolean;
  selectedRole: RoleEnum;
  onClose: (value: RoleEnum) => void;
}

const RoleSelectionModal = (props: roleSelectionProps) => {
  const { userWithRoles, updateCurrentUserActiveRole } = useUserContext();
  const { onClose, selectedRole, open } = props;
  const assignedRoles = userWithRoles?.roles;

  const handleClose = () => {
    onClose(selectedRole);
  };

  const handleUpdateRole = React.useCallback(
    async (selectedRole: RoleEnum) => {
      await updateCurrentUserActiveRole(selectedRole);
      onClose(selectedRole);
      window.location.href = settings.PUBLIC_URL + '/home';
    },
    [onClose, updateCurrentUserActiveRole],
  );
  console.log('window.location.href', window.location.href);

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>
        <Typography variant='inherit'>SELECT DESIRED ROLE</Typography>
      </DialogTitle>
      <List
        sx={{
          width: '100%',
          maxWidth: 360,
          bgcolor: '#005ea2',
          color: 'whitesmoke',
        }}
      >
        {assignedRoles?.map((role) => (
          <ListItem disablePadding key={role.id}>
            <ListItemButton onClick={() => handleUpdateRole(role.role)}>
              <ListItemIcon>
                <StarBorder sx={{ color: 'white' }} />
              </ListItemIcon>
              <ListItemText primary={role.role} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
};
const RoleModal = () => {
  const [open, setOpen] = React.useState(false);
  const [selectedRole, setSelectedRole] = React.useState<RoleEnum>('user');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (selectedRole: RoleEnum) => {
    setOpen(false);
    setSelectedRole(selectedRole);
  };
  return (
    <>
      <div style={{ padding: 1 }}>
        <Button
          variant='contained'
          onClick={handleClickOpen}
          role='button'
          aria-label='switch role'
        >
          Switch Role
        </Button>
      </div>
      <RoleSelectionModal
        selectedRole={selectedRole}
        open={open}
        onClose={handleClose}
      />
    </>
  );
};
export default RoleModal;
